import { Fetcher } from '@this/src/util';
import type { TripResponseArgs } from '@this/domain/trip/trip2';

type TripInfoResponse = {
  trip: TripResponseArgs;
  pusherKey: string;
  pusherChannelPrefix: string;
};

export type TripRealtimeInfo = {
  trip: TripResponseArgs;
  pusherKey: string;
  pusherChannelPrefix: string;
};

export const fetchTripInfo = async (tripId: string): Promise<TripRealtimeInfo> => {
  const response = await Fetcher.get<TripInfoResponse>(`/trips/${tripId}.json`);

  return {
    trip: response.trip,
    pusherKey: response.pusherKey,
    pusherChannelPrefix: response.pusherChannelPrefix
  };
};

export type DraftTrip = {
  tripId: string;
  lastMessage: string;
  createdAt: string;
};

type DraftTripResponse = {
  trip_id: number;
  last_message: string;
  created_at: string;
};

type FetchTripsResponse = {
  trips: DraftTripResponse[];
};

export const fetchDraftTrips = async (): Promise<DraftTrip[]> => {
  const response = await Fetcher.get<FetchTripsResponse>('/trips/ai_messages/trips.json', { draft: true });

  return response.trips.map(t => ({
    tripId: String(t.trip_id),
    lastMessage: t.last_message,
    createdAt: t.created_at
  }));
};
